import {CONSTANTS} from "./constant";

export function csvToData(csv) {
    let data = [];
    let rows = csv.split("\n");
    rows.forEach(row => {
        if (row)
            data.push(row.split(","));
    });
    return data;
}

export async function callService(postData, endpoint) {
    try {
        const response = await fetch(CONSTANTS.PHP_SCRIPT_BASE_PATH + endpoint, {
            method: 'POST',
            body: postData
        });

        const result = await response.json();
        const parsedData = csvToData(result.data);
        parsedData.shift();

        return parsedData;

    } catch (error) {
        console.error('Errore durante la richiesta:', error);
    }
}

export function processClick(interactionType, results) {
    const postDataInteractions = new FormData();

    postDataInteractions.append("interactionType", interactionType);
    postDataInteractions.append("folder", results.dataFolder);
    postDataInteractions.append("pdb", results.pdb);
    postDataInteractions.append("chain1", results.chain1);
    postDataInteractions.append("chain2", results.chain2);

    return callService(postDataInteractions, 'get_interactions.php');
}